var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99955 5.99967C7.4702 6.00317 6.96352 6.215 6.5892 6.58932C6.21488 6.96364 6.00305 7.47032 5.99955 7.99967C5.99955 9.09434 6.90489 9.99967 7.99955 9.99967C9.09355 9.99967 9.99955 9.09434 9.99955 7.99967C9.99955 6.90567 9.09355 5.99967 7.99955 5.99967Z",
    fill: "#8A9299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99954 3.33301C2.91088 3.33301 1.38154 7.74434 1.36754 7.78901L1.29688 7.99967L1.36688 8.21034C1.38154 8.25501 2.91088 12.6663 7.99954 12.6663C13.0882 12.6663 14.6175 8.25501 14.6315 8.21034L14.7022 7.99967L14.6322 7.78901C14.6175 7.74434 13.0882 3.33301 7.99954 3.33301ZM7.99954 11.333C4.43221 11.333 3.05021 8.76901 2.71554 7.99967C3.05154 7.22767 4.43421 4.66634 7.99954 4.66634C11.5669 4.66634 12.9489 7.23034 13.2835 7.99967C12.9475 8.77167 11.5649 11.333 7.99954 11.333Z",
    fill: "#8A9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.0334385cbc610128cf69a8007d7ccb1f.svg";
export { ForwardRef as ReactComponent };